/**
 * Tournament Model
 * 
 * Represents the tournament configuration and settings
 */
export default class Tournament {
  constructor({
    id = Date.now().toString(36),
    name = 'Soccer Tournament',
    format = '5v5', // '5v5', '7v7', '11v11'
    eventDuration = 120, // in minutes
    matchDuration = 10, // in minutes
    breakDuration = 2, // in minutes
    numberOfFields = 1,
    fields = [{id: 1, name: 'Field 1'}],
    hasFinals = true,
    created = new Date(),
    lastUpdated = new Date()
  } = {}) {
    this.id = id;
    this.name = name;
    this.format = format;
    this.eventDuration = eventDuration;
    this.matchDuration = matchDuration;
    this.breakDuration = breakDuration;
    this.numberOfFields = numberOfFields;
    this.fields = fields;
    this.hasFinals = hasFinals;
    this.created = created;
    this.lastUpdated = lastUpdated;
  }
  
  /**
   * Create a new Tournament instance from JSON data
   * @param {Object} data - JSON data
   * @returns {Tournament} New Tournament instance
   */
  static fromJSON(data) {
    return new Tournament({
      id: data.id,
      name: data.name,
      format: data.format,
      eventDuration: data.eventDuration,
      matchDuration: data.matchDuration,
      breakDuration: data.breakDuration || 2,
      numberOfFields: data.numberOfFields || 1,
      fields: data.fields || [{id: 1, name: 'Field 1'}],
      hasFinals: data.hasFinals !== undefined ? data.hasFinals : true,
      created: new Date(data.created),
      lastUpdated: new Date(data.lastUpdated)
    });
  }
  
  /**
   * Convert to JSON
   * @returns {Object} JSON representation
   */
  toJSON() {
    return {
      id: this.id,
      name: this.name,
      format: this.format,
      eventDuration: this.eventDuration,
      matchDuration: this.matchDuration,
      breakDuration: this.breakDuration,
      numberOfFields: this.numberOfFields,
      fields: this.fields,
      hasFinals: this.hasFinals,
      created: this.created.toISOString(),
      lastUpdated: this.lastUpdated.toISOString()
    };
  }
  
  /**
   * Update tournament properties
   * @param {Object} updates - Properties to update
   */
  update(updates) {
    Object.assign(this, updates);
    this.lastUpdated = new Date();
  }
  
  /**
   * Get the number of players per team based on format
   * @returns {number} Number of players per team
   */
  getPlayersPerTeam() {
    switch (this.format) {
      case '5v5': return 5;
      case '7v7': return 7;
      case '11v11': return 11;
      default: return 5;
    }
  }
}
